"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, createElement, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { baseMessages, createTranslator, defaultLocale, getBrowserLocale, localeLabels, mergeMessages, normalizeLocale, supportedLocales } from "./index.js";
const storageKey = "llmgateway.locale";
const cookieName = "llmgateway_locale";
const I18nContext = createContext(null);
export function I18nProvider(t0) {
  const $ = _c(17);
  const {
    children,
    defaultLocale: t1,
    messages
  } = t0;
  const initialLocale = t1 === undefined ? defaultLocale : t1;
  const [locale, setLocaleState] = useState(initialLocale);
  let t2;
  if ($[0] !== messages) {
    t2 = mergeMessages(baseMessages, messages);
    $[0] = messages;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const mergedMessages = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const storedLocale = readCookie(cookieName) ?? window.localStorage.getItem(storageKey);
      const nextLocale = storedLocale ?? getBrowserLocale(typeof navigator === "undefined" ? [] : navigator.languages);
      const normalized = normalizeLocale(nextLocale);
      setLocaleState(normalized);
      persistLocale(normalized);
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== locale) {
    t5 = () => {
      document.documentElement.lang = locale;
      document.documentElement.dir = "ltr";
    };
    t6 = [locale];
    $[4] = locale;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = nextLocale_0 => {
      const normalized_0 = normalizeLocale(nextLocale_0);
      setLocaleState(normalized_0);
      persistLocale(normalized_0);
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const setLocale = t7;
  let t8;
  if ($[8] !== locale || $[9] !== mergedMessages) {
    t8 = createTranslator(locale, mergedMessages);
    $[8] = locale;
    $[9] = mergedMessages;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t = t8;
  let t9;
  if ($[11] !== locale || $[12] !== t) {
    t9 = {
      locale,
      locales: supportedLocales,
      localeLabels,
      setLocale,
      t
    };
    $[11] = locale;
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const value = t9;
  let t10;
  if ($[14] !== children || $[15] !== value) {
    t10 = createElement(I18nContext.Provider, {
      value
    }, children);
    $[14] = children;
    $[15] = value;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useI18n must be used within I18nProvider.");
  }
  return context;
}
function readCookie(name) {
  const prefix = `${name}=`;
  const value = document.cookie.split(";").map(item => item.trim()).find(item => item.startsWith(prefix));
  return value ? decodeURIComponent(value.slice(prefix.length)) : undefined;
}
function persistLocale(locale) {
  window.localStorage.setItem(storageKey, locale);
  document.cookie = `${cookieName}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax`;
}